import Skeleton from 'src/Admin/components/common/skeleton';

const MemberDetailsSkeleton = () => (
  <>
    <div>
      <div className="usergrp-br">
        <div className="row">
          <div className="col-md-2">
            <Skeleton height={80} width={80} count={1} circle={true} />
          </div>

          <div className="col-md-4">
            <Skeleton count={1} width={200} height={10} />
            <div className="form-group">
              <Skeleton count={1} width={200} height={40} />
            </div>
          </div>
          <div className="col-md-6">
            <ul className="memberDetails">
              <li>
                {' '}
                <Skeleton count={1} />{' '}
              </li>
              <li>
                {' '}
                <Skeleton count={1} />{' '}
              </li>
              <li>
                {' '}
                <Skeleton count={1} />{' '}
              </li>
              <li>
                {' '}
                <Skeleton count={1} />{' '}
              </li>
              <li>
                {' '}
                <Skeleton count={1} />{' '}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="grpDivider"></div>
      <div className="memberData row">
        <div className="col">
          <Skeleton count={1} width={200} />
        </div>
      </div>

      <div className="d-flex flex-wrap">
        <div className="col-arrange">
          <div className="form-group">
            <label className="form-label">
              <Skeleton count={1} width={357} height={30} />
            </label>
            <p className="status-value1">
              <Skeleton count={1} width={357} height={30} />
            </p>
          </div>
        </div>

        <div className="col-arrange">
          <div className="form-group">
            <label className="form-label">
              <Skeleton count={1} width={357} height={30} />
            </label>
            <p className="status-value1">
              <Skeleton count={1} width={357} height={30} />
            </p>
          </div>
        </div>
      </div>

      <div className="grpDivider"></div>
      <div className="memberData mt-50 row">
        <div className="col">
          <h3>
            <Skeleton count={1} width={200} />
          </h3>
        </div>
      </div>

      <div className="d-flex flex-wrap">
        <div className="col-arrange">
          <Skeleton
            count={1}
            height={140}
            width={125}
            containerClassName={'memberBox-fields'}
          />
        </div>

        <div className="col-arrange">
          <Skeleton
            count={1}
            height={140}
            width={125}
            containerClassName={'memberBox-fields'}
          />
        </div>

        <div className="col-arrange">
          <Skeleton
            count={1}
            height={140}
            width={125}
            containerClassName={'memberBox-fields'}
          />
        </div>

        <div className="col-arrange">
          <Skeleton
            count={1}
            height={140}
            width={125}
            containerClassName={'memberBox-fields'}
          />
        </div>
        <div className="col-arrange">
          <Skeleton
            count={1}
            height={140}
            width={125}
            containerClassName={'memberBox-fields'}
          />
        </div>
      </div>

      {/*<div class="memberData mt-50 row">
        <div class="col">
          <a>
            <div class="memberBox">
              <Skeleton count={ 1 } height={ 140 } width={ 125 } containerClassName={ 'memberBox-fields' } />
            </div>
          </a>
        </div>
      </div> */}
    </div>
  </>
);
export default MemberDetailsSkeleton;
